import axiosInstance from "@/plugins/HTTP";
import authHeader from "./auth-header";
import { postMiddlewareFile } from "@/utils/apiMiddlewarePaths";

//Pass Same Param for authHeader and MiddlewareFile Method

class AuthService {

  //Layer
  login(user) {
    const form = new FormData();
    form.append("login", user.username);
    form.append("password", user.password);
    form.append("is_admin", user.is_admin);
    return axiosInstance.post(postMiddlewareFile("login"), form, {
      headers: authHeader("login"),
    })
    .then((response) => {
      return response.data;
    });
  }

}

export default new AuthService();
